import { Title } from '@gerdau/hefesto/Title';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ApplicationState } from '../../../../store';
import { loadFabricationOrderByIdSaga } from '../../../../store/ducks/fabrication-orders/actions';
import { IFabricationPurchaseOrderState } from '../../../../store/ducks/fabrication-purchase-order/types';
import { getFabricationPurchaseStateFromFabricationOrder } from '../../../../utils/purchaseHelpers';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import LoadingFabricationOrderModal from '../ConstructionIdentification/LoadingFabricationOrderModal';
import { Subtitle, Header, Container } from './styles';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import ConstructionIdentificationLastOrdersTable from '../ConstructionIdentification/ConstructionIdentificationLastOrdersTable';
import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';

interface ILastOrdersProps {
  onBuyAgain(fabricationPurchaseState: IFabricationPurchaseOrderState): void;
}

const LastOrders: React.FC<ILastOrdersProps> = ({ onBuyAgain }) => {
  const dispatch = useDispatch();
  const { location } = useHistory();
  const history = useHistory();

  const contractsState = useSelector(
    (appState: ApplicationState) => appState.fabricationContracts
  );

  const selectedOrderState = useSelector(
    (appState: ApplicationState) => appState.fabricationOrders.selectedOrder
  );

  const [showLoadingOrderModal, setShowLoadingOrderModal] = useState(false);

  const { screenName = '' } = getTaggingInformationScreen(
    location.pathname,
    true
  );

  const onBuyAgainClick = async (orderId: number) => {
    setShowLoadingOrderModal(true);
    dispatch(loadFabricationOrderByIdSaga(orderId));
  };

  useEffect(() => {
    dispatch(
      sendTagging({ screenName, page: location.pathname, event: 'page_view' })
    );
  }, []);

  useEffect(() => {
    if (selectedOrderState?.order) {
      const fabricationPurchaseState =
        getFabricationPurchaseStateFromFabricationOrder(
          selectedOrderState.order
        );
      onBuyAgain(fabricationPurchaseState);
    }
  }, [selectedOrderState?.order]);

  const goToConstructionIdentificationPage = () => {
    history.goBack();
  };

  return (
    <>
      <Header>
        <Button
          name="button-voltar"
          variant="tertiary"
          icon={<Icon option="ArrowLeft" />}
          onClick={goToConstructionIdentificationPage}
        >
          Voltar
        </Button>
        <Title level={2}>{`Histórico de pedidos - Contrato ${
          contractsState.selectedContract?.contractNumber ?? ''
        }`}</Title>
        {!!contractsState?.updatedAt && (
          <Subtitle>
            {`Atualizado em `}
            <span className={'date'}>
              {moment(contractsState.updatedAt).format('DD/MM/YYYY, HH:mm:ss')}
            </span>
          </Subtitle>
        )}
      </Header>
      <Container>
        <ConstructionIdentificationLastOrdersTable
          selectedContract={contractsState.selectedContract}
          onBuyAgainClick={onBuyAgainClick}
        />
        {showLoadingOrderModal && selectedOrderState && (
          <LoadingFabricationOrderModal
            loading={selectedOrderState.loading}
            error={selectedOrderState.error}
            orderNumber={selectedOrderState?.order?.orderNumber}
            onClose={() => setShowLoadingOrderModal(false)}
          />
        )}
      </Container>
    </>
  );
};

export default LastOrders;
